import { render, staticRenderFns } from "./Care.html?vue&type=template&id=52785ae2&external"
import script from "./Care.js?vue&type=script&lang=js&external"
export * from "./Care.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports